/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActivityLogDto } from '../models/activity-log-dto';
import { getActivityLog } from '../fn/user-activity-log/get-activity-log';
import { GetActivityLog$Params } from '../fn/user-activity-log/get-activity-log';
import { getActivityLogPageData } from '../fn/user-activity-log/get-activity-log-page-data';
import { GetActivityLogPageData$Params } from '../fn/user-activity-log/get-activity-log-page-data';
import { UserActivityDto } from '../models/user-activity-dto';

@Injectable({ providedIn: 'root' })
export class UserActivityLogService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getActivityLog()` */
  static readonly GetActivityLogPath = '/api/userActivityLog';

  /**
   * Get Activity Log.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivityLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityLog$Response(params?: GetActivityLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityLogDto>>> {
    return getActivityLog(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Activity Log.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActivityLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityLog(params?: GetActivityLog$Params, context?: HttpContext): Observable<Array<ActivityLogDto>> {
    return this.getActivityLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityLogDto>>): Array<ActivityLogDto> => r.body)
    );
  }

  /** Path part for operation `getActivityLogPageData()` */
  static readonly GetActivityLogPageDataPath = '/api/userActivityLog/full';

  /**
   * Get Activity Log Page Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivityLogPageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityLogPageData$Response(params?: GetActivityLogPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActivityDto>>> {
    return getActivityLogPageData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Activity Log Page Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActivityLogPageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityLogPageData(params?: GetActivityLogPageData$Params, context?: HttpContext): Observable<Array<UserActivityDto>> {
    return this.getActivityLogPageData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserActivityDto>>): Array<UserActivityDto> => r.body)
    );
  }

}
